import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-login-and-reg-dialog',
  templateUrl: './login-and-reg-dialog.component.html',
  styleUrls: ['./login-and-reg-dialog.component.scss']
})
export class LoginAndRegDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string }
  ) {
  }

}
